import { zim } from '../../zegoConfig'; // ZIM instance
import { zegoEngine } from '../../zegoCallConfig'; // ZegoExpressEngine instance
import { generateZegoToken } from './generateToken'; // Fungsi buat token lokal

/**
 * Fungsi login ke ZIM (chat) dan ZegoExpressEngine (video)
 */
export const loginToZego = async (userId: string, username: string, roomID: string): Promise<boolean> => {
  try {
    console.log('🔑 Generate token for user:', userId);
    const zegoToken = generateZegoToken(userId, 3600); // 1 jam

    if (!zegoToken) throw new Error('Token kosong');

    // ✅ Login ke ZIM (chat)
    await zim.login({ userID: userId, userName: username }, zegoToken);
    console.log('✅ Login ke ZIM berhasil', zegoToken);

    // ✅ Login ke ZegoExpressEngine (video call)
    const result = await zegoEngine.loginRoom(
      roomID,
      zegoToken,
      { userID: userId, userName: username },
      { userUpdate: true }
    );

    if (result === true) {
      console.log('✅ Login ke ZegoExpressEngine berhasil');
      return true;
    } else {
      console.error('❌ Login ke ZegoExpressEngine gagal');
      return false;
    }
  } catch (error) {
    console.error('❌ Gagal login ke ZIM/ZegoEngine:', error);
    return false;
  }
};
